import SeedPhraseIcon from './SeedPhraseIcon'

export default SeedPhraseIcon
